import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DadosService } from '../db/dados.service';
import { MaterialIcons } from '../../../comum/services/icons.service';
import { AppEditorModule } from '../controls/editor';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TermoDocumentoComponent } from './termo-documento/termoDocumento'
import { TermoServicosComponent } from './termo-servicos/termoServicos';
import { TermoAfiliadosComponent } from './termo-afiliados/termoAfiliados';
import { TermoPrivacidadeComponent } from './termo-privacidade/termoPrivacidade';
import { VerDocumentoComponent } from '../../../comum/controls/mat-ver-documento';
import { SharedModule } from "../shared/shared.module";
import { MatDataGridModule } from '../../../comum/controls/mat-datagrid-module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FornCadastroComponent } from './forn-cadastro/forn-cadastro.component';
import { FornListaComponent } from "./forn-cadastro/forn-lista";
import { PagesComponent } from '../views/pages/pages.component';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ControlsModule } from '../controls/controls.module';

import { ProdutoListaComponent } from './produtos/produto-lista.component';
import { ProdutoComplementoControl } from './produtos/produto-complemento';
import { ProdutoAdicionaisControl } from './produtos/produto-adicionais';
import { ProdutoReferenciaComponent } from './produtos/produto-referencia.component';

import { LocalidadesComponent } from './localidades/localidades.component';
import { SplashComponent } from './splash/splash.component';
import { CategoriasComponent } from './categorias/categorias.component';
import { OperacoesComponent } from './operacoes/operacoes';
import { PublicidadesComponent } from './publicidades/publicidades.component';
import { MeiosPagamentoComponent } from './meios-pagamento/meios-pagamento.component';
import { SubCategoriasComponent } from './sub-categorias/sub-categorias.component';
import { EstadoItensComponent } from './estado-itens/estado-itens.component';
import { ComentariosModule } from './produtos/produto-comentarios';
import { TotalizadoresComponent } from './totalizadores/totalizadores.component';
import { ListaSugestoesComponent } from './sugestoes/lista-sugestoes';
import { DadosLojaComponent } from './dados-loja/dados-loja.component';
import { AnexosComponent } from './anexos/anexos.component';
import { RegiaoControl } from './forn-cadastro/regiao-control.component';
import { PedidosNovosComponent } from './pedidos-novos/pedidos-novos.component';
import { MinhasVendasComponent } from './minhas-vendas/minhas-vendas.component';
import { MinhasVendasFornecedorComponent } from './minhas-vendas/minhas-vendas-fornecedor.component';
import { PedidosNovosDialogComponent } from './pedidos-novos-dialog/pedidos-novos-dialog.component';
import { VendasDetalheComponent } from './minhas-vendas/vendas-detalhe/vendas-detalhe.component';
import { MinhasVendasAdminComponent } from './minhas-vendas/minhas-vendas-admin/minhas-vendas-admin.component';
import { ConfigsComponent } from './configs/configs.component';
import { UserTrocarSenhaComponent } from './users/users_trocar_senha.component';
import { ServicosCategoriasComponent } from './servicos/servicos-categorias';

export const routes: Routes = [
  {
    path: '', component: PagesComponent,
    children: [
      { path: '', loadChildren: '../views/dashboard/dashboard.module#DashboardModule', data: { breadcrumb: 'Dashboard' } },
      { path: 'menu', loadChildren: '../views/dashboard/dashboard.module#DashboardModule', data: { breadcrumb: 'Dashboard' } },
      { path: 'users', loadChildren: '../views/users/users.module#UsersModule', data: { breadcrumb: 'Usuários' } },
      { path: 'trocarSenha', component: UserTrocarSenhaComponent, data: { breadcrumb: 'Senha' } },
      //      { path: 'schedule', loadChildren: '../pages/schedule/schedule.module#ScheduleModule', data: { breadcrumb: 'Schedule' } },
      { path: 'maps', loadChildren: '../views/maps/maps.module#MapsModule', data: { breadcrumb: 'Maps' } },
      { path: 'chat', loadChildren: '../views/chat/chat.module#ChatModule', data: { breadcrumb: 'Chat' } },

      { path: 'fornecedores', component: FornListaComponent, data: { breadcrumb: 'Fornecedores' } },
      { path: 'dadosLoja', component: DadosLojaComponent, data: { breadcrumb: 'Loja' } },
      {
        path: 'produtosFornecedor/:fornecedor', component: ProdutoListaComponent, data: { breadcrumb: 'Produtos' },
        children: [
          { path: '', component: ProdutoListaComponent },
        ]
      },
      { path: 'produtos', component: ProdutoListaComponent },
      { path: 'listaNaoEncontrados/:fornecedor', component: ListaSugestoesComponent, data: { breadcrumb: "Lista Sugestões" } },
      //{ path: 'naoAtendidos', component: }
      { path: 'localidades', component: LocalidadesComponent, data: { breadcrumb: 'Localidades' } },
      { path: 'categorias', component: CategoriasComponent, data: { breadcrumb: 'Categorias' } },
      { path: 'operacoes', component: OperacoesComponent, data: { breadcrumb: 'Operações' } },
      { path: 'subCategorias/:categoria', component: SubCategoriasComponent, data: { breadcrumb: 'SubCategorias' } },
      { path: 'publicidades', component: PublicidadesComponent, data: { breadcrumb: 'Publicidades' } },
      { path: 'meiosPagamento', component: MeiosPagamentoComponent, data: { breadcrumb: 'MeiosPagamento' } },
      { path: 'splash', component: SplashComponent },
      { path: 'estados', component: EstadoItensComponent, data: { breadcrumb: 'Estados' } },
      { path: 'termoServicos', component: TermoServicosComponent },
      { path: 'termoAfiliados', component: TermoAfiliadosComponent },
      { path: 'termoPrivacidade', component: TermoPrivacidadeComponent },
      { path: 'documento/:ident', component: TermoDocumentoComponent },
      { path: 'verDocumento/:ident', component: VerDocumentoComponent },
      { path: 'totalizadores', component: TotalizadoresComponent },
      { path: 'configs', component: ConfigsComponent },
      { path: 'servicosCategorias', component: ServicosCategoriasComponent, data: { breadcrumb: 'Serviços-Categorias' } },
      { path: 'anexos', component: AnexosComponent },
      {
        path: 'vendasDiaria', component: MinhasVendasFornecedorComponent, data: { breadcrumb: 'Vendas diária' }
        , children: [
          { path: 'detalhe/:pedido', component: VendasDetalheComponent, data: { breadcrumb: 'Detalhes' } }
        ]
      },
      {
        path: 'minhasVendas', component: MinhasVendasComponent, data: { breadcrumb: 'Vendas' }
        , children: [
          {
            path: 'vendasDiaria', component: MinhasVendasFornecedorComponent, data: { breadcrumb: 'Vendas diária' }
            , children: [
              { path: 'detalhe/:pedido', component: VendasDetalheComponent, data: { breadcrumb: 'Detalhes' } }
            ]
          },
          { path: 'vendasDiaria/:fornecedor/:data', component: MinhasVendasFornecedorComponent, data: { breadcrumb: 'Vendas diária' } }
        ]
      }
    ]
  }]

@NgModule({
  providers: [
    DadosService,
    MaterialIcons,
  ],
  imports: [
    FormsModule, ReactiveFormsModule,
    CommonModule,
    SharedModule,
    // NgxDatatableModule,
    ControlsModule,
    FlexLayoutModule,
    MatDataGridModule,
    EditorModule,
    AppEditorModule,
    RouterModule.forRoot(routes, {
      //  preloadingStrategy: PreloadAllModules,  // <- comment this line for activate lazy load
      //  useHash: true
    }),
    ComentariosModule,
  ],
  declarations: [
    //EditorComponent,
    TermoDocumentoComponent,
    TermoServicosComponent,
    TermoAfiliadosComponent,
    TermoPrivacidadeComponent,
    VerDocumentoComponent,
    FornCadastroComponent,
    FornListaComponent,
    ProdutoListaComponent,
    LocalidadesComponent,
    SplashComponent, CategoriasComponent,
    PublicidadesComponent, MeiosPagamentoComponent,
    SubCategoriasComponent, EstadoItensComponent,
    TotalizadoresComponent,
    OperacoesComponent,

    ProdutoListaComponent,
    ProdutoReferenciaComponent,
    ProdutoComplementoControl,
    ProdutoAdicionaisControl,

    DadosLojaComponent,
    AnexosComponent,
    RegiaoControl,
    PedidosNovosComponent,
    ListaSugestoesComponent,
    MinhasVendasComponent,
    MinhasVendasFornecedorComponent,
    PedidosNovosDialogComponent,
    VendasDetalheComponent,
    MinhasVendasAdminComponent,
    MinhasVendasAdminComponent,
    ConfigsComponent,
    UserTrocarSenhaComponent,
    ServicosCategoriasComponent,
  ],
  exports: [
    PedidosNovosComponent
  ],
  entryComponents: [
    PedidosNovosDialogComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ViewsModule { }


/*
export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
  //preloadingStrategy: PreloadAllModules,  // <- comment this line for activate lazy load
  // useHash: true
});
*/